import { render, staticRenderFns } from "./PaymentItem.vue?vue&type=template&id=71573ded&scoped=true"
import script from "./PaymentItem.vue?vue&type=script&lang=js"
export * from "./PaymentItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentItem.vue?vue&type=style&index=0&id=71573ded&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71573ded",
  null
  
)

export default component.exports